import * as signalR from "@microsoft/signalr";
import { Middleware } from "redux";
import { RootState, TransactionCallbackResponse } from "../config/types";
import * as ActionTypes from "../config/ActionTypes";
import { purchaseFailed, purchaseSuccess } from "../action_creators/purchases.actions";
import { urlHelper } from "../../helpers/urlHelper";
import {
  isTerminalFailureForResult,
  isTerminalSuccessForResult,
  isTransitionalForResult,
} from "../../helpers/paymentCallbackState";

const startSignalRConnection = async (connection: signalR.HubConnection, sessionId: string, message: string) => {
  return await connection
    .start()
    .then(() => {
      console.log("signalR done");
      connection.send(message, sessionId); //Todo: are these the props we want/need to send?
      return connection;
    })
    .catch((error) => {
      console.log("signalR error: " + error);
    });
};

const signalRMiddleware: Middleware<
  {}, // legacy type parameter added to satisfy interface signature
  RootState
> = (store) => (next) => (action) => {
  const connectionHub = urlHelper.getHubUrl();
  const protocol = new signalR.JsonHubProtocol();
  //const transport = signalR.HttpTransportType.WebSockets;

  const options = {
    skipNegotiation: true,
    transport: signalR.HttpTransportType.WebSockets
  };

  const connection = new signalR.HubConnectionBuilder()
    .withUrl(connectionHub, options)
    .configureLogging(signalR.LogLevel.Critical)
    .withHubProtocol(protocol)
    .build();

  //connection.onclose(() => setTimeout(startSignalRConnection(connection), 5000));

  connection.on("TransactionCallback", (transactionCallbackResponse: TransactionCallbackResponse) => {
    console.log("TransactionCallback received: " + JSON.stringify(transactionCallbackResponse));
    if (isTransitionalForResult(transactionCallbackResponse)) {
      return;
    }

    const sessionId = store.getState().purchases.sessionId;
    if (sessionId) {
      connection.send("PlexoDisconnect", sessionId);
    }
    connection.stop();

    if (isTerminalSuccessForResult(transactionCallbackResponse)) {
      next(purchaseSuccess(transactionCallbackResponse));
      return;
    }

    if (isTerminalFailureForResult(transactionCallbackResponse)) {
      next(purchaseFailed(transactionCallbackResponse.message, transactionCallbackResponse));
      return;
    }

    next(purchaseFailed(transactionCallbackResponse.message, transactionCallbackResponse));
  });

  if (action.type === ActionTypes.GET_URL_SUCCESS) {
    startSignalRConnection(connection, action.sessionId, "PlexoInit");
  }

  if (action.type === ActionTypes.PAGE_REDIRECTED) {
    // got sessionId from query string
    console.log("PAGE REDIRECTED, starting signalR connection");
    startSignalRConnection(connection, action.sessionId, "RedirectStatus");
  }

  return next(action);
};

export default signalRMiddleware;
